import React from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const Layout = ({ children, showSidebar = true }) => {
  const { user } = useSelector((state) => state.auth);
  const location = useLocation();

  return (
    <React.Fragment>
      <Navbar />
      <div className="layout-content columns mt-1" style={{ paddingTop:"20px",minHeight: "100vh" }}>
        {showSidebar && location.pathname !== "/" && (
          <div className="column is-2">
            <Sidebar />
          </div>
        )}
        <div className={`column has-background-light ${showSidebar && location.pathname !== "/" ? "" : "is-fullwidth"}`}>
          <main>{children}</main>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Layout;
